module.exports = __webpack_public_path__ + "img/oam.f8e050ea.png";